import styled from 'styled-components';

const Total = styled.span`
    font-family: ${props => props.theme.text.type.bold};
    font-size: 3rem;
`;

export default Total;
